import { connect } from 'react-redux'
import TipoCadastro from './tipoCadastro'
import { withRouter } from 'react-router-dom';
import { bindActionCreators } from 'redux'
import {
  refreshStepDadosBancario,
  refreshTipoContratoAction,
  selecionarTipoPessoaAction,
  selecionarTipoProdutoAction,
  getListTipoProdutoAction,
  selecionarTipoNecessidadeAction,
  setDadosIniciaisCodigoGerenteAction
} from '../../store/tipoCadastro/actions'
import { getNavegationStepsAction } from '../../store/navegationSteps/actions'
import { configuracaoDdi } from '../../store/ddi/actions'


const makeValidProducts =({ navegations }, { tipoPessoaValue, tipoNecessidade, listTipoProduto }) => {
  let produtos = [];

  if (navegations && navegations.hasOwnProperty(tipoPessoaValue)) {
    const necessidade = tipoNecessidade === 'EnviarParaExterior' ? 'Enviar' : 'Receber';

    produtos = navegations[tipoPessoaValue].Produtos.filter((p) => p[necessidade]);
  }

  const validProducts = listTipoProduto
    .filter((tipoProduto) => produtos.findIndex((p) => p.Id === tipoProduto.IdProduto) > -1)
    .map(item => ({ value: item.IdProduto, name: item.IdProduto, label: item.Nome }));

  return validProducts;
}

const mapStateToProps = (state, nextState) => ({
  tipoCadastro: state.tipoCadastroReducer,
  navegations: state.navegationStepsReducer.navegations,
  produtos : makeValidProducts(state.navegationStepsReducer, state.tipoCadastroReducer)
});

const mapDispatchToProps = dispatch =>
bindActionCreators({
  configuracaoDdi,
  refreshStepDadosBancario,
  setDadosIniciaisCodigoGerenteAction,
  refreshTipoContratoAction,
  selecionarTipoPessoaAction,
  selecionarTipoProdutoAction,
  getListTipoProdutoAction,
  selecionarTipoNecessidadeAction,
  getNavegationStepsAction
}, dispatch); 

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(TipoCadastro));
